export type QrStatus = 'active' | 'inactive';

export interface PermanentQrEntry {
  id: number;
  radioId: number;
  radioName: string;
  frequency: string;
  plan: string;
  redirectCode: string;
  permanentUrl: string;
  qrStatus: QrStatus;
  logoUrl: string;
  currentDomain: string | null;
  domainType: 'rfw_subdomain' | 'custom_domain' | null;
  hasDomain: boolean;
  createdAt: string;
  lastScanCount: number;
  destinationType: 'custom_domain' | 'rfe_page';
  destinationLabel: string;
  destinationUrl: string;
}

export const permanentQrData: PermanentQrEntry[] = [
  {
    id: 1,
    radioId: 101,
    radioName: 'Radio Nueva Actitud',
    frequency: '94.70 RFW',
    plan: 'Empresarial',
    redirectCode: 'nueva-actitud',
    permanentUrl: 'radiofrecuenciaweb.com/r/nueva-actitud',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20logo%20circular%20design%2C%20warm%20golden%20amber%20colors%2C%20sound%20wave%20symbol%2C%20clean%20corporate%20style%2C%20abstract%20geometric%20mark%2C%20high%20contrast%20professional%20brand%20identity&width=120&height=120&seq=sa-qr-logo-1&orientation=squarish',
    currentDomain: 'nuevaactitud.com',
    domainType: 'custom_domain',
    hasDomain: true,
    createdAt: '2025-11-15',
    lastScanCount: 2847,
    destinationType: 'custom_domain',
    destinationLabel: 'nuevaactitud.com',
    destinationUrl: 'https://nuevaactitud.com',
  },
  {
    id: 2,
    radioId: 102,
    radioName: 'Radio Ritmo Latino',
    frequency: '101.30 RFW',
    plan: 'Oro',
    redirectCode: 'ritmo-latino',
    permanentUrl: 'radiofrecuenciaweb.com/r/ritmo-latino',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Latin%20radio%20station%20logo%20design%2C%20vibrant%20warm%20colors%20red%20orange%20coral%2C%20tropical%20music%20theme%2C%20circular%20emblem%2C%20modern%20flat%20design%2C%20clean%20background%20professional%20brand%20mark&width=120&height=120&seq=sa-qr-logo-2&orientation=squarish',
    currentDomain: 'ritmolatino.rfw.fm',
    domainType: 'rfw_subdomain',
    hasDomain: true,
    createdAt: '2025-08-22',
    lastScanCount: 5103,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/101.30',
  },
  {
    id: 3,
    radioId: 103,
    radioName: 'Radio Éxitos TV',
    frequency: '94.70 RFW',
    plan: 'Empresarial',
    redirectCode: 'exitos-tv',
    permanentUrl: 'radiofrecuenciaweb.com/r/exitos-tv',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Professional%20radio%20station%20logo%2C%20bold%20modern%20design%2C%20metallic%20silver%20and%20crimson%20red%20accents%2C%20broadcast%20tower%20icon%2C%20sleek%20corporate%20identity%2C%20high%20contrast%20minimalist%20style&width=120&height=120&seq=sa-qr-logo-3&orientation=squarish',
    currentDomain: 'exitostv.net',
    domainType: 'custom_domain',
    hasDomain: true,
    createdAt: '2025-09-05',
    lastScanCount: 9234,
    destinationType: 'custom_domain',
    destinationLabel: 'exitostv.net',
    destinationUrl: 'https://exitostv.net',
  },
  {
    id: 4,
    radioId: 104,
    radioName: 'Radio Fiesta Mix',
    frequency: '88.50 RFW',
    plan: 'Pro',
    redirectCode: 'fiesta-mix',
    permanentUrl: 'radiofrecuenciaweb.com/r/fiesta-mix',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Energetic%20radio%20station%20logo%2C%20neon%20pink%20and%20electric%20blue%20colors%2C%20party%20music%20theme%2C%20circular%20abstract%20design%2C%20modern%20vibrant%20brand%20identity%20for%20youth%20audience&width=120&height=120&seq=sa-qr-logo-4&orientation=squarish',
    currentDomain: null,
    domainType: null,
    hasDomain: false,
    createdAt: '2025-12-01',
    lastScanCount: 1205,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/88.50',
  },
  {
    id: 5,
    radioId: 105,
    radioName: 'Radio Pirata FM',
    frequency: '99.90 RFW',
    plan: 'Oro',
    redirectCode: 'pirata-fm',
    permanentUrl: 'radiofrecuenciaweb.com/r/pirata-fm',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Rebel%20radio%20station%20logo%2C%20dark%20skull%20and%20crossbones%20radio%20theme%2C%20edgy%20underground%20design%2C%20black%20and%20crimson%20colors%2C%20grunge%20aesthetic%20brand%20identity&width=120&height=120&seq=sa-qr-logo-5&orientation=squarish',
    currentDomain: 'piratafm.rocks',
    domainType: 'custom_domain',
    hasDomain: true,
    createdAt: '2026-01-10',
    lastScanCount: 7601,
    destinationType: 'custom_domain',
    destinationLabel: 'piratafm.rocks',
    destinationUrl: 'https://piratafm.rocks',
  },
  {
    id: 6,
    radioId: 106,
    radioName: 'Radio Sonora Digital',
    frequency: '103.70 RFW',
    plan: 'Oro',
    redirectCode: 'sonora-digital',
    permanentUrl: 'radiofrecuenciaweb.com/r/sonora-digital',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%2C%20warm%20terracotta%20and%20sand%20colors%2C%20acoustic%20guitar%20and%20sombrero%20elements%2C%20circular%20traditional%20modern%20fusion%20design%2C%20professional%20brand%20identity&width=120&height=120&seq=sa-qr-logo-6&orientation=squarish',
    currentDomain: 'sonoradigital.com',
    domainType: 'custom_domain',
    hasDomain: true,
    createdAt: '2026-02-14',
    lastScanCount: 3421,
    destinationType: 'custom_domain',
    destinationLabel: 'sonoradigital.com',
    destinationUrl: 'https://sonoradigital.com',
  },
  {
    id: 7,
    radioId: 107,
    radioName: 'Radio Stereo Visión',
    frequency: '96.10 RFW',
    plan: 'Empresarial',
    redirectCode: 'stereo-vision',
    permanentUrl: 'radiofrecuenciaweb.com/r/stereo-vision',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Urban%20radio%20station%20logo%2C%20graffiti%20street%20art%20style%2C%20vibrant%20purple%20and%20lime%20green%20colors%2C%20city%20skyline%20element%2C%20modern%20hip%20hop%20culture%20brand%20identity&width=120&height=120&seq=sa-qr-logo-7&orientation=squarish',
    currentDomain: 'stereovision.rfw.fm',
    domainType: 'rfw_subdomain',
    hasDomain: true,
    createdAt: '2025-08-01',
    lastScanCount: 1890,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/96.10',
  },
  {
    id: 8,
    radioId: 108,
    radioName: 'Radio Clásica FM',
    frequency: '88.90 RFW',
    plan: 'Oro',
    redirectCode: 'clasica-fm',
    permanentUrl: 'radiofrecuenciaweb.com/r/clasica-fm',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20radio%20station%20logo%2C%20sophisticated%20gold%20and%20ivory%20palette%2C%20violin%20and%20orchestra%20elements%2C%20refined%20circular%20emblem%2C%20luxury%20brand%20identity%20for%20cultured%20audience&width=120&height=120&seq=sa-qr-logo-8&orientation=squarish',
    currentDomain: 'clasicafm.net',
    domainType: 'custom_domain',
    hasDomain: true,
    createdAt: '2025-12-01',
    lastScanCount: 4562,
    destinationType: 'custom_domain',
    destinationLabel: 'clasicafm.net',
    destinationUrl: 'https://clasicafm.net',
  },
  {
    id: 9,
    radioId: 109,
    radioName: 'Radio Urbana 101',
    frequency: '101.10 RFW',
    plan: 'Empresarial',
    redirectCode: 'urbana-101',
    permanentUrl: 'radiofrecuenciaweb.com/r/urbana-101',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Street%20culture%20radio%20logo%2C%20bold%20graffiti%20typography%2C%20urban%20concrete%20texture%2C%20orange%20and%20black%20color%20scheme%2C%20edgy%20underground%20brand%20identity%20for%20hip%20hop%20station&width=120&height=120&seq=sa-qr-logo-9&orientation=squarish',
    currentDomain: 'urbana101.com',
    domainType: 'custom_domain',
    hasDomain: true,
    createdAt: '2025-10-20',
    lastScanCount: 11234,
    destinationType: 'custom_domain',
    destinationLabel: 'urbana101.com',
    destinationUrl: 'https://urbana101.com',
  },
  {
    id: 10,
    radioId: 110,
    radioName: 'Radio Élite Digital',
    frequency: '107.50 RFW',
    plan: 'Oro',
    redirectCode: 'elite-digital',
    permanentUrl: 'radiofrecuenciaweb.com/r/elite-digital',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=News%20radio%20station%20logo%2C%20professional%20serious%20design%2C%20navy%20blue%20and%20silver%20metallic%2C%20globe%20and%20microphone%20elements%2C%20authoritative%20corporate%20brand%20identity%20for%20journalism&width=120&height=120&seq=sa-qr-logo-10&orientation=squarish',
    currentDomain: null,
    domainType: null,
    hasDomain: false,
    createdAt: '2024-06-01',
    lastScanCount: 8921,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/107.50',
  },
  {
    id: 11,
    radioId: 111,
    radioName: 'La Voz del Llano',
    frequency: '92.30 RFW',
    plan: 'Empresarial',
    redirectCode: 'voz-del-llano',
    permanentUrl: 'radiofrecuenciaweb.com/r/voz-del-llano',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Folk%20radio%20station%20logo%2C%20traditional%20rural%20design%2C%20earth%20tones%20green%20and%20brown%2C%20harp%20and%20landscape%20elements%2C%20rustic%20circular%20brand%20identity%20for%20regional%20music&width=120&height=120&seq=sa-qr-logo-11&orientation=squarish',
    currentDomain: 'lavozdelllano.com',
    domainType: 'custom_domain',
    hasDomain: true,
    createdAt: '2026-02-14',
    lastScanCount: 3876,
    destinationType: 'custom_domain',
    destinationLabel: 'lavozdelllano.com',
    destinationUrl: 'https://lavozdelllano.com',
  },
  {
    id: 12,
    radioId: 112,
    radioName: 'Radio Universo Online',
    frequency: '95.80 RFW',
    plan: 'Pro',
    redirectCode: 'universo-online',
    permanentUrl: 'radiofrecuenciaweb.com/r/universo-online',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Indie%20radio%20station%20logo%2C%20minimalist%20cosmic%20design%2C%20deep%20purple%20and%20teal%20space%20colors%2C%20planet%20and%20sound%20wave%20elements%2C%20modern%20alternative%20brand%20identity%20for%20young%20creatives&width=120&height=120&seq=sa-qr-logo-12&orientation=squarish',
    currentDomain: null,
    domainType: null,
    hasDomain: false,
    createdAt: '2026-04-05',
    lastScanCount: 654,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/95.80',
  },
  {
    id: 13,
    radioId: 113,
    radioName: 'Radio Festival TV',
    frequency: '100.20 RFW',
    plan: 'Empresarial',
    redirectCode: 'festival-tv',
    permanentUrl: 'radiofrecuenciaweb.com/r/festival-tv',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Festival%20radio%20station%20logo%2C%20vibrant%20confetti%20colorful%20design%2C%20orange%20magenta%20and%20yellow%2C%20stage%20lights%20elements%2C%20energetic%20circular%20brand%20identity%20for%20live%20events&width=120&height=120&seq=sa-qr-logo-13&orientation=squarish',
    currentDomain: 'festivaltv.net',
    domainType: 'custom_domain',
    hasDomain: true,
    createdAt: '2025-07-10',
    lastScanCount: 12540,
    destinationType: 'custom_domain',
    destinationLabel: 'festivaltv.net',
    destinationUrl: 'https://festivaltv.net',
  },
  {
    id: 14,
    radioId: 114,
    radioName: 'Radio Brisas del Mar',
    frequency: '89.70 RFW',
    plan: 'Básico',
    redirectCode: 'brisas-del-mar',
    permanentUrl: 'radiofrecuenciaweb.com/r/brisas-del-mar',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Tropical%20radio%20station%20logo%2C%20ocean%20breeze%20theme%2C%20turquoise%20and%20sandy%20beige%20colors%2C%20palm%20tree%20and%20sun%20elements%2C%20relaxed%20circular%20brand%20identity%20for%20beach%20vibes&width=120&height=120&seq=sa-qr-logo-14&orientation=squarish',
    currentDomain: null,
    domainType: null,
    hasDomain: false,
    createdAt: '2026-03-01',
    lastScanCount: 410,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/89.70',
  },
  {
    id: 15,
    radioId: 115,
    radioName: 'Radio Juventud Stereo',
    frequency: '104.50 RFW',
    plan: 'Pro',
    redirectCode: 'juventud-stereo',
    permanentUrl: 'radiofrecuenciaweb.com/r/juventud-stereo',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Youth%20radio%20station%20logo%2C%20bright%20cheerful%20design%2C%20neon%20cyan%20and%20hot%20pink%20colors%2C%20emoji%20and%20digital%20elements%2C%20modern%20circular%20brand%20identity%20for%20teen%20audience&width=120&height=120&seq=sa-qr-logo-15&orientation=squarish',
    currentDomain: null,
    domainType: null,
    hasDomain: false,
    createdAt: '2026-05-10',
    lastScanCount: 892,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/104.50',
  },
  {
    id: 16,
    radioId: 116,
    radioName: 'Radio Folclor Andino',
    frequency: '91.40 RFW',
    plan: 'Básico',
    redirectCode: 'folclor-andino',
    permanentUrl: 'radiofrecuenciaweb.com/r/folclor-andino',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Andean%20folk%20radio%20logo%2C%20traditional%20mountain%20design%2C%20warm%20earth%20tones%20terracotta%20and%20ochre%2C%20quena%20flute%20and%20mountain%20elements%2C%20circular%20cultural%20brand%20identity&width=120&height=120&seq=sa-qr-logo-16&orientation=squarish',
    currentDomain: null,
    domainType: null,
    hasDomain: false,
    createdAt: '2025-11-20',
    lastScanCount: 178,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/91.40',
  },
  {
    id: 17,
    radioId: 117,
    radioName: 'Radio Retro Hits',
    frequency: '98.60 RFW',
    plan: 'Oro',
    redirectCode: 'retro-hits',
    permanentUrl: 'radiofrecuenciaweb.com/r/retro-hits',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Retro%20radio%20station%20logo%2C%20vintage%20vinyl%20record%20design%2C%20warm%20sepia%20and%20mustard%20colors%2C%20nostalgic%2080s%20aesthetic%2C%20circular%20classic%20brand%20identity%20for%20oldies%20station&width=120&height=120&seq=sa-qr-logo-17&orientation=squarish',
    currentDomain: null,
    domainType: null,
    hasDomain: false,
    createdAt: '2026-01-05',
    lastScanCount: 3456,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/98.60',
  },
  {
    id: 18,
    radioId: 118,
    radioName: 'Radio TechBeats',
    frequency: '106.20 RFW',
    plan: 'Pro',
    redirectCode: 'tech-beats',
    permanentUrl: 'radiofrecuenciaweb.com/r/tech-beats',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Electronic%20music%20radio%20logo%2C%20futuristic%20cyberpunk%20design%2C%20dark%20background%20with%20neon%20green%20and%20electric%20blue%2C%20digital%20waveform%2C%20sleek%20modern%20brand%20identity%20for%20tech%20music&width=120&height=120&seq=sa-qr-logo-18&orientation=squarish',
    currentDomain: null,
    domainType: null,
    hasDomain: false,
    createdAt: '2026-04-20',
    lastScanCount: 2100,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/106.20',
  },
  {
    id: 19,
    radioId: 119,
    radioName: 'Radio Deportiva Total',
    frequency: '93.80 RFW',
    plan: 'Oro',
    redirectCode: 'deportiva-total',
    permanentUrl: 'radiofrecuenciaweb.com/r/deportiva-total',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%2C%20dynamic%20energetic%20design%2C%20bold%20red%20and%20white%20colors%2C%20soccer%20ball%20and%20microphone%20elements%2C%20circular%20action%20brand%20identity%20for%20sports%20fans&width=120&height=120&seq=sa-qr-logo-19&orientation=squarish',
    currentDomain: null,
    domainType: null,
    hasDomain: false,
    createdAt: '2025-09-15',
    lastScanCount: 6701,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/93.80',
  },
  {
    id: 20,
    radioId: 120,
    radioName: 'Radio Gospel Internacional',
    frequency: '87.90 RFW',
    plan: 'Básico',
    redirectCode: 'gospel-internacional',
    permanentUrl: 'radiofrecuenciaweb.com/r/gospel-internacional',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Gospel%20radio%20station%20logo%2C%20spiritual%20serene%20design%2C%20soft%20gold%20and%20white%20colors%2C%20dove%20and%20light%20rays%20elements%2C%20circular%20peaceful%20brand%20identity%20for%20Christian%20music&width=120&height=120&seq=sa-qr-logo-20&orientation=squarish',
    currentDomain: null,
    domainType: null,
    hasDomain: false,
    createdAt: '2026-02-28',
    lastScanCount: 2340,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/87.90',
  },
  {
    id: 21,
    radioId: 121,
    radioName: 'Radio Deep House Nights',
    frequency: '92.80 RFW',
    plan: 'Pro',
    redirectCode: 'deep-house-nights',
    permanentUrl: 'radiofrecuenciaweb.com/r/deep-house-nights',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Deep%20house%20radio%20logo%2C%20moody%20atmospheric%20design%2C%20dark%20teal%20and%20electric%20indigo%20colors%2C%20geometric%20wave%20patterns%2C%20sophisticated%20modern%20brand%20identity%20for%20electronic%20music&width=120&height=120&seq=sa-qr-logo-21&orientation=squarish',
    currentDomain: null,
    domainType: null,
    hasDomain: false,
    createdAt: '2026-05-01',
    lastScanCount: 456,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/92.80',
  },
  {
    id: 22,
    radioId: 122,
    radioName: 'Radio Azul Tropical',
    frequency: '97.30 RFW',
    plan: 'Oro',
    redirectCode: 'azul-tropical',
    permanentUrl: 'radiofrecuenciaweb.com/r/azul-tropical',
    qrStatus: 'active',
    logoUrl: 'https://readdy.ai/api/search-image?query=Tropical%20Caribbean%20radio%20logo%2C%20bright%20turquoise%20and%20sunny%20yellow%20design%2C%20palm%20silhouette%20and%20music%20note%20elements%2C%20circular%20vibrant%20brand%20identity%20for%20island%20music&width=120&height=120&seq=sa-qr-logo-22&orientation=squarish',
    currentDomain: null,
    domainType: null,
    hasDomain: false,
    createdAt: '2026-03-15',
    lastScanCount: 1230,
    destinationType: 'rfe_page',
    destinationLabel: 'Perfil en RadioFrecuenciaWeb',
    destinationUrl: '/radio/97.30',
  },
];

export function getPermanentQrByRadioId(radioId: number): PermanentQrEntry | undefined {
  return permanentQrData.find((q) => q.radioId === radioId);
}

export function getPermanentQrByCode(code: string): PermanentQrEntry | undefined {
  return permanentQrData.find((q) => q.redirectCode === code);
}